import React, { useState } from "react";
import { Languages } from "@wuilt/ui-components";
import { FormattedMessage } from "react-intl";
import DropDown from "../components/DropDwon";
import classnames from "classnames";
import styles from "./LanguageSwitcher.module.scss";
import { languages as languagesData } from "./languages";
import useElements from "../hooks/useElements";
import DropArrowIcon from "./DropArrowIcon";
function LanguageSwitcher(props) {
  const [isShowOptions, setShowOptions] = useState(false);
  const {
    base
  } = useElements();
  const Link = base?.Link;
  const {
    displayClass,
    dropTo,
    withLabel,
    labelClass,
    withIcon,
    iconClass,
    languages,
    dropDownClass,
    showDivider = true,
    noAction
  } = props;
  const LinkComponent = noAction ? "div" : Link;
  const renderDropDown = direction => {
    const classes = classnames({
      [styles.dropDown]: true,
      [styles.dropDirectionUp]: direction === "up"
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classes
    }, /*#__PURE__*/React.createElement(DropDown, {
      direction: direction,
      className: dropDownClass,
      id: "inputGroupSelect01",
      visible: isShowOptions
    }, languages.map(language => /*#__PURE__*/React.createElement(DropDown.Item, {
      key: language.iso,
      selected: language.active
    }, /*#__PURE__*/React.createElement(LinkComponent, {
      className: styles.languageLink,
      href: language.link
      // onClick={(e) => {
      // e.preventDefault();
      // onChangeEditorLocale(language);
      // }}
    }, languagesData[language.iso].name)))));
  };
  const isOpenToTop = dropTo === "top";
  if (languages.length === 1) {
    return null;
  }
  const activeLanguage = languages.find(language => language.active);
  const classes = classnames(styles.wrapper, displayClass);
  const dropArrowClasses = classnames({
    [styles.dropArrow]: true,
    [styles.dropDirectionUp]: isOpenToTop
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.styledFlex
  }, showDivider && /*#__PURE__*/React.createElement("span", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes,
    onMouseLeave: () => setShowOptions(false)
  }, isOpenToTop && renderDropDown("up"), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.labelWrapper, labelClass),
    onMouseEnter: () => setShowOptions(true)
  }, withIcon && /*#__PURE__*/React.createElement("i", {
    className: `la la-${withIcon} ${iconClass}`
  }), withLabel && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: "Language:",
    id: "fiNfmb"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.styledFlex
  }, /*#__PURE__*/React.createElement(Languages, {
    size: "22px",
    className: styles.languagesIcon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.languageName
  }, languagesData[activeLanguage?.iso].name)), /*#__PURE__*/React.createElement(DropArrowIcon, {
    dropArrowClasses: dropArrowClasses
  })), !isOpenToTop && renderDropDown("down")));
}
export default LanguageSwitcher;
//# sourceMappingURL=LanguageSwitcher.js.map